// @flow
import { defineMessages } from 'react-intl';

export const customisationErrors = defineMessages({
    conflictStatusError: {
        id: 'groups.errors.conflict-status-error',
        defaultMessage: `We were unable to save the changes to this group because one light can only be in one group at a time. Please try again.`
    }
});



// WEBPACK FOOTER //
// ./src/core/state/groups/intl.js